import styled from 'styled-components';

export const Button = styled.a`
  background:${({ primary }) => (primary ? '#000' : '#0001da')};
  height:100%;
  z-index:10;
  cursor:pointer;
  height:${({ big }) => (big ? '50px' : '30px')};
  width:100px;
  min-width:100px;
  max-width:210px;
  display:flex;
  align-items:center;
  justify-content:center;
  text-decoration:none;
  transition:0.3s;
  color:#fff;
  padding:0rem 1rem;
  &:hover{
    transform:translateY(-2px);
  
  }
  border-radius:10px;
  `